<template>
  <k-checkbox
    v-show="show"
    v-model="val"
    :label="label || title"
    :rules="rules"
    :required="required||false"
  ></k-checkbox>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'name',
    'label',
    'title',
    'required'
  ],
  computed: {
    rules () {
      if(this.required) {
        return [
          v => !!v || this.label+' is required'
        ]
      }
      return [];
    },
    val: {
      get () {
        return _.get(this.value, this.name) || false;
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
